import { SET_USER_PERMISSION, USER_INFO_SUCCESS, SET_ACCOUNT_SETTINGS, LOGIN_SUCCESS } from './types';
import config from 'config';
import { get, size } from 'global/lib/lodash';
import sendData from 'redux/actions/sendData';
import { UserPermission } from 'global/lib/filter';
import { reduxStore } from '../../index';
import { flattenAllRealms, parseJson, wait } from 'global/utils';
import { store } from 'redux/configureStore';

export const userLogin = (username, password) => async (dispatch, getState) => {
  const result = await sendData(
    {
      url: '/oauth/token',
      method: 'post',
      data: {
        grant_type: 'password',
        client_id: config.api.clientId,
        client_secret: config.api.clientSecret,
        username: username,
        password: password,
      },
    },
    {
      useNamespace: false,
      useAuth: false,
    }
  );

  dispatch({ type: LOGIN_SUCCESS, payload: get(result, 'data') });

  const userresult = await sendData({ url: '/user' }, { useNamespace: false });

  dispatch({ type: USER_INFO_SUCCESS, payload: get(userresult, 'data') });
};

export const sendAuthCode = (username, code) => async (dispatch, getState) => {
  await sendData(
    {
      url: '/mfa-auth',
      method: 'post',
      data: {
        data: {
          email: username,
          mfa_email_code: code,
        }
      },
    },
    {
      useNamespace: false,
      useAuth: false,
      maxTries: 1,
    }
  );
};

export const getUserPermissions = () => async (dispatch, getState) => {
  const sState = getState();
  const uid = get(sState, 'auth.user.id');
  if (uid) {
    const uperm = await sendData({ url: `/users/${uid}?include=permissions,realm,realms,userGroups` }, { normalize: { build: ['users'] } });
    const user = get(uperm, '0');
    const realms = flattenAllRealms(get(user, 'realms')).map((r) => {
      return { ...r, realms: undefined };
    });
    dispatch({ type: USER_INFO_SUCCESS, payload: { ...user, realms } });
    dispatch({ type: SET_USER_PERMISSION, permissions: get(uperm, '0.permissions') });
  } else {
    await wait();
    await dispatch(getUserPermissions());
  }
};

export const userHasPermissions = (perms = []) => {
  //perms come over as manageAccount, createTasks and so forth
  //user must have ALL permissions in the perms array
  if (typeof perms === 'string') {
    perms = [perms];
  }
  const { store } = reduxStore;
  const sState = store.getState();
  const permissions = get(sState, 'auth.permissions', []);

  const has = perms.filter((p) => {
    const up = UserPermission.find((up) => up.value === p);
    if (!up) {
      return undefined;
    }
    return permissions.find((pe) => pe.name.indexOf(up.match) > -1);
  });
  return size(has) >= size(perms);
};

export const userHasAtLeastOnePermission = (perms = []) => {
  //This function is used to check if the user has at least one of the permissions in perms list
  if (typeof perms === 'string') {
    perms = [perms];
  }
  const { store } = reduxStore;
  const sState = store.getState();
  const permissions = get(sState, 'auth.permissions', []);

  const has = perms.filter((p) => {
    const up = UserPermission.find((up) => up.value === p);
    if (!up) {
      return undefined;
    }
    return permissions.find((pe) => pe.name.indexOf(up.match) > -1);
  });
  return size(has) > 0;
};

export const getAccountSettings = () => async (dispatch, getState) => {
  const sState = getState();
  const uid = get(sState, 'auth.user.id');
  if (uid) {
    const accountSettings = await sendData({ url: `/account-settings` }, { normalize: { build: ['accountSettings'] } });

    dispatch({ type: SET_ACCOUNT_SETTINGS, accountSettings });
  } else {
    await wait();
    await dispatch(getAccountSettings());
  }
};

export const getAccountSetting = (key) => {
  try {
    const { getState } = store;
    const { accountSettings } = getState().auth;
    // Use the last matching entry — realm-scoped overrides are appended after base settings
    const obj = [...accountSettings].reverse().find((as) => get(as, 'name') === key);
    const val = get(obj, 'value');
    const str = parseJson(val, val);
    return str;
  } catch (err) {
    console.warn(err);
    debugger;
  }
};
